export default "data:image/gif;base64,R0lGODlhEgAMAPECAADMAP+qAP///+Xl5SH5BAAAAAAALAAAAAASAAwAAAIlhD+pwX0nomzuATlpsBcLvVnep3EjaHqoqJYstj6nK7cUpyxaAQA7"